import { SET_SPIN_COMPANY_ID } from '../types/spinPremiaTypes';

export function setSpinCompanyId(order) {

    let spinCompanyId = ''
    try {
        if (order.order_details.length > 0) {
            const haveMembership = order.order_details.find(o => o.product_type_id === 3)
            if (haveMembership !== undefined) {
                spinCompanyId = haveMembership.company_id
            } else {
                spinCompanyId = order.order_details[0].company_id
            }
        }
    } catch (error) {
        
    }

    return {
        type: SET_SPIN_COMPANY_ID,
        payload: spinCompanyId,
    };
}
